import React, { useMemo } from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../components/NtText";
import NtMaterialIcon from "../../components/NtMaterialIcon";
import { useTheme } from "../../context/ThemeContext";

function NtPinItem({ containerStyle, number, enabled = true, showStatus = true }) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);
  const bg = enabled ? theme.brand : theme.surface3;
  const fg = enabled ? "#ffffff" : theme.textDim;

  return (
    <View style={[styles.container, { backgroundColor: bg }, containerStyle]}>
      {showStatus && (
        <NtMaterialIcon
          containerStyle={{ marginTop: -2, marginBottom: -2 }}
          name={enabled ? "check-circle" : "information"}
          color={fg}
          size={14}
        />
      )}
      <NtText style={[styles.text, { color: fg, marginLeft: 4 }]}>{number}</NtText>
    </View>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    container: {
      paddingHorizontal: 8,
      paddingVertical: 3,
      borderRadius: t.radius,
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      alignSelf: "flex-start",
    },
    text: { fontSize: 11, fontWeight: "700" },
  });

export default NtPinItem;
